import { useEffect, useRef } from 'react'

export default function usePrevious<T>(state: T): T | null {
  const ref = useRef<T | null>(null)

  useEffect(() => {
    ref.current = state
  })

  return ref.current
}

